/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Asse di validazione (pattern input) dell\'attributo dichiarato dal bando
 */
export enum ValidationType {

    RAW = 'RAW',

    EMAIL = 'EMAIL',

    PHONE = 'PHONE',

    CODICE_FISCALE = 'CODICE_FISCALE',

    CURRENCY = 'CURRENCY'
}

